import { getBarrios } from "../../../api/barrios";
import { getTipos } from "../../../api/tipos";
import { asignarSolicitudes, getInspectores } from "../../../services/admin.service";
import { useAdminStore } from "../../../store/adminStore";

const { setInspectores, setRefetch, clearSoliciutdesAsignar } = useAdminStore.getState();

export const cargaDatos = async (setTipos, setBarrios, setLoading) => {
  setLoading(true);
  await getTipos(setTipos);
  await getBarrios(setBarrios);
  setLoading(false);
};

export const getInspectoresHandler = async () => {
  const resp = await getInspectores();
  if (resp) {
    setInspectores(resp);
  }
};

export const asignarSolicitudesHandler = async (payload) => {
  const resp = await asignarSolicitudes(payload);
  if (resp) {
    clearSoliciutdesAsignar();
    setRefetch(true);
    // console.log(resp);
    // setInspectores(resp);
  }
};
